import { c as _c } from "react/compiler-runtime";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { usePatientPortal } from "@/contexts/patient-portal-provider";
import { getPortalLoyaltyPoints, listPortalMembershipBenefits, listPortalPackageBenefits, listPortalSavedItemBenefits } from "@/api/patient/portal-benefits";
export const portalBenefitsQueryKeys = {
  all: ["patient-portal", "benefits"] as const,
  packages: (userScope: string) => [...portalBenefitsQueryKeys.all, "packages", userScope] as const,
  savedItems: (userScope: string) => [...portalBenefitsQueryKeys.all, "saved-items", userScope] as const,
  memberships: (userScope: string) => [...portalBenefitsQueryKeys.all, "memberships", userScope] as const,
  loyaltyPoints: (userScope: string) => [...portalBenefitsQueryKeys.all, "loyalty-points", userScope] as const
};
export function usePortalPackageBenefits(options) {
  const $ = _c(5);
  const {
    patient
  } = usePatientPortal();
  const userScope = patient?.id ?? "";
  let t0;
  if ($[0] !== userScope) {
    t0 = portalBenefitsQueryKeys.packages(userScope);
    $[0] = userScope;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const t1 = !!userScope && (options?.enabled ?? true);
  let t2;
  if ($[2] !== t0 || $[3] !== t1) {
    t2 = {
      queryKey: t0,
      queryFn: listPortalPackageBenefits,
      enabled: t1,
      select: _temp
    };
    $[2] = t0;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return useQuery(t2);
}
function _temp(data) {
  return data ?? [];
}
export function patientSavedItemBenefitsQueryOptions(userScope: string | null, options?: {
  enabled?: boolean;
  refetchInterval?: number | false;
}) {
  const scope = userScope ?? "";
  return queryOptions({
    queryKey: portalBenefitsQueryKeys.savedItems(scope),
    queryFn: () => listPortalSavedItemBenefits(),
    enabled: !!scope && (options?.enabled ?? true),
    refetchInterval: options?.refetchInterval,
    select: data => data ?? []
  });
}
export function usePatientSavedItemBenefits(userScope, options) {
  const $ = _c(3);
  let t0;
  if ($[0] !== options || $[1] !== userScope) {
    t0 = patientSavedItemBenefitsQueryOptions(userScope, options);
    $[0] = options;
    $[1] = userScope;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return useQuery(t0);
}
export function usePortalSavedItemBenefits(options) {
  const {
    patient
  } = usePatientPortal();
  return usePatientSavedItemBenefits(patient?.id ?? null, options);
}
export function usePortalMembershipBenefits(options) {
  const $ = _c(5);
  const {
    patient
  } = usePatientPortal();
  const userScope = patient?.id ?? "";
  let t0;
  if ($[0] !== userScope) {
    t0 = portalBenefitsQueryKeys.memberships(userScope);
    $[0] = userScope;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const t1 = !!userScope && (options?.enabled ?? true);
  let t2;
  if ($[2] !== t0 || $[3] !== t1) {
    t2 = {
      queryKey: t0,
      queryFn: listPortalMembershipBenefits,
      enabled: t1,
      select: _temp2
    };
    $[2] = t0;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return useQuery(t2);
}
function _temp2(data) {
  return data ?? [];
}
export function usePortalLoyaltyPoints(options) {
  const $ = _c(5);
  const {
    patient
  } = usePatientPortal();
  const userScope = patient?.id ?? "";
  let t0;
  if ($[0] !== userScope) {
    t0 = portalBenefitsQueryKeys.loyaltyPoints(userScope);
    $[0] = userScope;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const t1 = !!userScope && (options?.enabled ?? true);
  let t2;
  if ($[2] !== t0 || $[3] !== t1) {
    t2 = {
      queryKey: t0,
      queryFn: getPortalLoyaltyPoints,
      enabled: t1
    };
    $[2] = t0;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return useQuery(t2);
}